// extracted by mini-css-extract-plugin
export default {"main1":"styles_main1__vFpRq","imgDiv":"styles_imgDiv__1stOz","infoDiv":"styles_infoDiv__PcV2f"};